<template>
    <div style="background-color: #f2f1f7;overflow: hidden">
        <div class="headBox">
            <img src="../../assets/img/return.png" alt="" class="refund" @click="refund">
            <img :src="userData.pc_logo" alt="" style="max-width: 160px">
            <div class="siteName">
                运营商中心
<!--                <span>企业端</span>-->
            </div>
        </div>
        <!--        左侧导航-->
        <div style="height: 93vh;overflow: scroll">
            <div style="min-width:1400px;min-height: 100%">
                <leftSide style="float:left;"></leftSide>
                <div style="margin-left: 250px;padding: 10px 0px">
                    <router-view></router-view>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import leftSide from '@/views/operatorCenter/components/leftSide.vue';

export default {
    name: "operatorCenter",
    components: { leftSide },
    data(){
        return{
            userData:''
        }
    },
    methods:{
        refund(){
            this.$router.push('/index')
        }
    },
    created() {
        this.userData = JSON.parse(localStorage.getItem('userData'));
    }
}
</script>

<style scoped>
    .headBox{
        display: flex;
        align-items: center;
        height: 7vh;
        background-color: #2350b5;
    }
    .refund{
        height: 24px;
        margin-left: 10px;
        margin-right: 50px;
        cursor:pointer;
    }
    .siteName{
        margin: 0px 35px;
        font-size: 22px;
        color: #fff;
    }
    .siteName>span{
        font-size: 14px;
        font-weight: 600;
        margin-left: 20px;
    }
</style>